<template>
  <div class="login">
    <h1 class="section-title">
      {{ $t("Thanks for verifying your e-mail") }}
    </h1>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import axios from "@/helpers/axios";
export default {
  name: "VerifyEmail",
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"])
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("e-mail Verified"));
    axios.post("/auth/registration/verify-email/", {
      key: this.$route.query.key
    });
  }
};
</script>
